import React, { createContext, useState } from "react";

const GlobalStateContext = createContext();

const GlobalStateProvider = ({ children }) => {
  const [index, setIndex] = useState("");
  const [indexType, setIndexType] = useState("default");

  return (
    <GlobalStateContext.Provider
      value={{
        index,
        setIndex,
        indexType,
        setIndexType,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export { GlobalStateContext, GlobalStateProvider };
